import { render, staticRenderFns } from "./ApproveButton.vue?vue&type=template&id=03e060c7"
import script from "./ApproveButton.vue?vue&type=script&lang=ts"
export * from "./ApproveButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports